export const ENDPOINTS = {
    POST: {
        GOTTI_AUTHENTICATE: '__gotti_authenticate',
        GOTTI_JOIN_GAME: '__gotti_join_game',
        GOTTI_GAMES_LIST: '__gotti_games_list',
    },
    GET: {}
}

export enum PROTOCOLS {
    GAME_MESSAGE,
    SERVER_TO_CLIENT_GAME_REQUEST,
    
    SYSTEM_MESSAGE,    
    SYSTEM_STATE_SYNC,
    MULTI_SYSTEM_STATE_SYNC,
    CLIENT_TO_SERVER_MESSAGE_INSTANT,
    SERVER_TO_CLIENT_MESSAGE_INSTANT,

    CLIENT_TO_SERVER_MESSAGE,
    CLIENT_TO_SERVER_REQUEST,

    CLIENT_TO_DIRECT_AREA_SERVER_MESSAGE,
    CLIENT_TO_DIRECT_AREA_SERVER_MESSAGE_INSTANT,

    MASTER_GLOBAL_BROADCAST,
    MASTER_SYSTEM_MESSAGE,
    SERVER_TO_CLIENT_REQUEST,

    SEND_TO_CHANNEL,

    AREA_TO_CONNECTOR_ADD_TO_CHANNEL,
    AREA_TO_CONNECTOR_REMOVE_FROM_CHANNEL,
    AREA_TO_CONNECTOR_CHANNEL_MESSAGE,
    AREA_TO_CONNECTOR_CHANNEL_REQUEST,
    CONNECTOR_TO_AREA_CHANNEL_RESPONSE,
    AREA_TO_CONNECTOR_DESTROY_CHANNEL,

    CLIENT_ADDED_TO_AREA_BY_AREA,
    CLIENT_JOINED_AREA,
    CLIENT_JOINED_AREAS,
    CLIENT_LEFT_AREA,

    PEER_SIGNAL_SUCCESS,
    PEER_SIGNAL_REQUEST,
    PEER_CONNECTION_REQUEST,
    PEER_CONNECTION_REQUEST_FAILED,
    PEER_CONNECTION_REQUEST_SUCCESS,
    PEER_SIGNAL_FAILED,

    AREA_REQUEST_RELAY,
    AREA_RELAY,
    AREA_RELAYS,
    CONNECTOR_REQUEST,

    UPDATE_SYSTEM_CODE,

    REQUEST_JOIN_AREA,
    GET_FIRST_AREAS,
    AREA_STATE_SYNC,
    AREA_STATE_UPDATE,

    // udp protocols
    SERVER_ACK,
    CLIENT_ACK,
    PING,
    CLIENT_CLOSE,


    GAME_REQUEST,
    CLIENT_TO_SERVER_RAW_MESSAGE,
    SERVER_TO_CLIENT_RAW_MESSAGE,

    // Connector→client: a client-namespace asset changed (Unified Assets API).
    ASSET_CHANGED,

    SERVER_REQUESTED_RECONNECT,

    // Client→server: a DELIBERATE leave (client.close()/clearGame()). Sent
    // best-effort BEFORE the socket is torn down so the connector can mark the
    // impending disconnect as intentional — the area evicts immediately and the
    // gate purges auth now, instead of the grace-hold/detach path reserved for
    // abnormal drops (where a reconnect may follow). If the socket dies without
    // this frame first (a crash), the grace path applies.
    CLIENT_LEAVING,
}

export enum LEAVE_AREA_REASONS {
    DISCONNECTED,
    REMOVED_BY_AREA,
    SWITCHED_AREA,
}

export enum PEER_TO_PEER_PROTOCOLS {
    PING,
    PONG
}

export enum GATE_TO_CONNECTOR_PROTOCOLS {
    CLIENT_DISCONNECTED,
    CLIENT_CHANGING_CONNECTORS,
    REDIRECT_MESSAGE_TO_CLIENT,
    FINISHED_RESERVATION,
    // Connector→gate: this client joined/left an area. The gate keeps the list
    // so a rejoin can be routed from SERVER state instead of client assertion,
    // and sizes its own auth hold to the longest area grace window.
    // [proto, privateId, areaId, joined, graceMs]
    CLIENT_AREA_CHANGED,
}


export enum CONNECTOR_MASTER_REQUEST_PROTOCOLS {
    AREA_RELAY,
    FINISHED_RESERVATION_GET_INITIAL_AREAS,
}

export enum GATE_CONNECTOR_REQUEST_PROTOCOLS {
    CHECK_CLIENT,
    RESERVE_SEAT,
    ASK_FOR_CLIENT_CONNECTOR,
    PEER_CONNECTION_REQUEST,
    PEER_SIGNAL_REQUEST,
    // Gate→connector: drop this client's transport now. Used when a second
    // login for the same identity TAKES OVER the live session.
    // [proto, privateId] → true if the connector had that client, false if not.
    DISCONNECT_CLIENT,
}

/*
export enum CONNECTOR_TO_AREA_PROTOCOLS {
    CLIENT_MESSAGE,
    CLIENT_SYSTEM_REQUEST,
    REQUEST_JOIN_AREA,
    JOIN_AREA,
    ADD_TO_AREA,
    AREA_TO_AREA_MESSAGE,
    AREA_TO_AREA_REQUEST
}
*/
export enum MESSAGE_TYPES {
}

export enum SYSTEM_TYPES {
}

export const WEBRTC_RELIABLE_CHANNEL = 'reliable';
export const WEBRTC_UNRELIABLE_CHANNEL = 'unreliable';
/** Default TURN/STUN servers used when WebRTC config omits iceServers. */
export const DEFAULT_WEBRTC_ICE_SERVERS = [
    'stun:stun.l.google.com:19302',
    'stun:stun1.l.google.com:19302',
    'stun:stun2.l.google.com:19302',
    'stun:stun3.l.google.com:19302',
    'stun:stun4.l.google.com:19302',
] as const;

export const RECONNECT_GRACE_MS = 60_000;
export const CLIENT_RECONNECT_MAX_ATTEMPTS = 10;
export const CLIENT_RECONNECT_BACKOFF_MS = 500;
export const CLIENT_RECONNECT_BACKOFF_CAP_MS = 5_000;